var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNavegaciNPersonas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 15.25c2.071 0 3.75 1.679 3.75 3.75v.75h-1.5V19c0-1.243-1.007-2.25-2.25-2.25H3.98c-1.231 0-2.23.999-2.23 2.23v.75H.25v-.75c0-2.06 1.67-3.73 3.73-3.73zM9.999.248c3.728 0 6.751 3.023 6.751 6.751s-3.023 6.751-6.751 6.751-6.751-3.023-6.751-6.751S6.271.248 9.999.248zm0 1.5c-2.9 0-5.251 2.351-5.251 5.251 0 2.9 2.351 5.251 5.251 5.251 2.9 0 5.251-2.351 5.251-5.251 0-2.9-2.351-5.251-5.251-5.251z",
    transform: "translate(-829 -485) translate(829 485) translate(2 2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavegaciNPersonas);
export default __webpack_public_path__ + "static/media/icons-navegaci-n-personas.74e948dc.svg";
export { ForwardRef as ReactComponent };